import Icon from '../components/Icon.vue'

Icon.register({
  'align-left': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M12.8 352c-7.1 0-12.8-5.7-12.8-12.8v0-38.3 0c0-7.1 5.7-12.8 12.8-12.8h0 262.3 0c7.1 0 12.8 5.7 12.8 12.8v0 38.3 0c0 7.1-5.7 12.8-12.8 12.8h0-262.3zM12.8 96c-7.1 0-12.8-5.7-12.8-12.8v0-38.3 0c0-7.1 5.7-12.8 12.8-12.8h0 262.3 0c7.1 0 12.8 5.7 12.8 12.8v0 38.3 0c0 7.1-5.7 12.8-12.8 12.8h0-262.3zM432 160c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-416c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h416zM432 416c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-416c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h416z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/align-left.js
// module id = 593
// module chunks = 0